module.exports = __webpack_public_path__ + "assets/img/menu-jury.9fb2bd5e.svg";